import { Controller } from '@hotwired/stimulus';

export default class UboFormController extends Controller {
  static targets = ['title', 'formSelect'];
  static values = { titleTemplate: String };

  titleTargetConnected() {
    this.#renumber();
  }

  titleTargetDisconnected() {
    this.#renumber();
  }

  formSelectTargetConnected(select) {
    this.#initSelect2(select);
  }

  #renumber() {
    this.titleTargets.forEach((btn, idx) => {
      const span = btn.querySelector('span');
      if (span) span.textContent = this.titleTemplateValue.replace('{index}', idx + 1);
    });
  }

  #initSelect2(select) {
    const $ = window.jQuery;
    if (!$ || typeof $.fn?.select2 !== 'function') return;

    const $el = $(select);
    if ($el.data('select2') !== undefined) return;

    const options = { minimumResultsForSearch: Infinity, width: '100%' };
    if ($el.find('option[value=""]').length) {
      options.placeholder = ' ';
    }
    $el.select2(options);
  }
}
